import React, { useEffect, useState } from "react";
import "../sass/components/modalNumeroDeSerie.scss";

const gerarNumeroSerie = (codCad, dias) => {
  const codCadFormatado = String(codCad ?? "").replace(/\D/g, "").padStart(9, "0");
  if (codCadFormatado.length !== 9) throw new Error("Código de cadastro inválido após formatação.");

  const diasNum = Number.parseInt(dias, 10);
  if (!Number.isInteger(diasNum) || diasNum > 40 || diasNum < 1) throw new Error("Dias deve ser um número entre 1 e 40.");

  const agora = new Date();
  const hojeUtc = Date.UTC(agora.getFullYear(), agora.getMonth(), agora.getDate());
  const baseOADate = Date.UTC(1899, 11, 30);
  const diffDias = Math.floor((hojeUtc - baseOADate) / 86400000);
  const somaFormatada = String(diffDias + diasNum).padStart(9, "0");

  const P0 = codCadFormatado.substring(0, 3);
  const P1 = codCadFormatado.substring(3, 6);
  const P2 = codCadFormatado.substring(6, 9);
  const P3 = somaFormatada.substring(0, 3);
  const P4 = somaFormatada.substring(3, 6);
  const P5 = somaFormatada.substring(6, 9);
  return `${P0}${P5}${P1}${P4}${P2}${P3}`;
};

const ModalNumeroSerie = ({ isOpen, onClose, codigoCadastro }) => {
  const [codCad, setCodCad] = useState("");
  const [dias, setDias] = useState("1");
  const [numeroSerie, setNumeroSerie] = useState("");
  const [erro, setErro] = useState("");
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setCodCad(String(codigoCadastro ?? ""));
    setDias("1");
    setNumeroSerie("");
    setErro("");
    setCopiado(false);
  }, [isOpen, codigoCadastro]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (event) => event.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleGerar = () => {
    try {
      setNumeroSerie(gerarNumeroSerie(codCad, dias));
      setErro("");
      setCopiado(false);
    } catch (error) {
      setErro(error.message);
      setNumeroSerie("");
    }
  };

  const copiar = async () => {
    if (!numeroSerie) return;
    try {
      await navigator.clipboard.writeText(numeroSerie);
      setCopiado(true);
    } catch {
      setErro("Não foi possível copiar automaticamente. Selecione o número manualmente.");
    }
  };

  return (
    <div className="modal-serie-overlay" onMouseDown={onClose}>
      <section className="modal-numero-serie" role="dialog" aria-modal="true" aria-labelledby="modal-serie-title" onMouseDown={(event) => event.stopPropagation()}>
        <header><div><span>Utilitário de suporte</span><h2 id="modal-serie-title">Gerar número de série</h2><p>Liberação temporária entre 1 e 40 dias.</p></div><button type="button" onClick={onClose} aria-label="Fechar">×</button></header>

        <div className="modal-serie-body">
          <label><span>Código do cadastro</span><input type="text" value={codCad} disabled readOnly /></label>
          <label><span>Dias de liberação</span><input type="number" min={1} max={40} value={dias} onChange={(event) => {setDias(event.target.value);setErro("");setNumeroSerie("");}} /></label>

          {numeroSerie ? (
            <div className="resultado"><span>Número gerado</span><strong>{numeroSerie}</strong><button type="button" onClick={copiar}>{copiado ? "Copiado" : "Copiar"}</button></div>
          ) : null}
          {erro ? <div className="erro">{erro}</div> : null}
        </div>

        <footer><button type="button" className="btn-secondary" onClick={onClose}>Fechar</button><button type="button" className="btn-primary" onClick={handleGerar}>Gerar número</button></footer>
      </section>
    </div>
  );
};

export default ModalNumeroSerie;
